import { CreateUnRealisedIncomeReportReduxState, UnRealisedIncomeReducerDispatch, UnRealisedIncomeReduxTypes } from "./types"

const CREATE_UNREALISED_INCOME_REPORT_INITIAL_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateUnrealisedIncomeReportReducer = (state: CreateUnRealisedIncomeReportReduxState = CREATE_UNREALISED_INCOME_REPORT_INITIAL_STATE, action: UnRealisedIncomeReducerDispatch) => {
    switch (action.type) {
        case UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT:

            return {
                ...state,
                loading: true
            }
        case UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT_SUCCESS:

            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        case UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT_ERROR:

            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        default:
            return { ...state }
    }
}

export { CreateUnrealisedIncomeReportReducer }